import React from "react";
import { Alert, Snackbar } from "@mui/material";
import { colors } from "../ui/colors";

export const SnackbarAlert = ({
  openState,
  setOpenState,
  duration = 6000,
  severity = "info",
  message,
  position = "bottom-center",
  scope = "global",
  sx = {},
}) => {
  const isCustomMessage = React.isValidElement(message);

  const getAlertStyle = (severity) => {
    switch (severity) {
      case "success":
        return {
          backgroundColor: colors.success[100],
          color: colors.success[700],
          border: `1px solid ${colors.success.base}`,
          "& .MuiAlert-icon": { color: colors.success.base },
        };
      case "info":
        return {
          backgroundColor: colors.info[100],
          color: colors.info[700],
          border: `1px solid ${colors.info.base}`,
          "& .MuiAlert-icon": { color: colors.info.base },
        };
      case "warning":
        return {
          backgroundColor: colors.warning[100],
          color: colors.warning[700],
          border: `1px solid ${colors.warning.base}`,
          "& .MuiAlert-icon": { color: colors.warning.base },
        };
      case "error":
      case "danger":
        return {
          backgroundColor: colors.danger[100],
          color: colors.danger[700],
          border: `1px solid ${colors.danger.base}`,
          "& .MuiAlert-icon": { color: colors.danger.base },
        };
      default:
        return {
          backgroundColor: colors.gray[100],
          color: colors.gray[700],
          border: `1px solid ${colors.gray[300]}`,
          "& .MuiAlert-icon": { color: colors.gray[500] },
        };
    }
  };

  const positionMap = {
    "bottom-left": { bottom: 16, left: 16 },
  };

  // Map para scope="global"
  const anchorOriginMap = {
    "top-left": { vertical: "top", horizontal: "left" },
    "top-right": { vertical: "top", horizontal: "right" },
    "top-center": { vertical: "top", horizontal: "center" },
    "bottom-left": { vertical: "bottom", horizontal: "left" },
    "bottom-right": { vertical: "bottom", horizontal: "right" },
    "bottom-center": { vertical: "bottom", horizontal: "center" },
  };

  const globalPositionOffset =
    position === "top-left"
      ? {
          top: { xs: 88, md: 88 },
          left: { xs: 16, md: 288, lg: 330 },
          width: { xs: "calc(100vw - 32px)", sm: 360, md: 420 },
          maxWidth: "calc(100vw - 32px)",
        }
      : {};

  return (
    <Snackbar
      open={openState}
      autoHideDuration={duration}
      onClose={() => setOpenState(false)}
      disablePortal={scope === "local"}
      anchorOrigin={scope === "global" ? anchorOriginMap[position] : undefined}
      sx={{
        zIndex: 999999, 
        ...(scope === "local"
          ? {
              position: "absolute",
              maxWidth: "90%",
              width: "auto",
              ...positionMap[position],
            }
          : {
              position: "fixed",
              ...globalPositionOffset,
            }),
        ...sx,
      }}
    >
      <Alert
        icon={isCustomMessage ? false : undefined}
        onClose={() => setOpenState(false)}
        severity={severity === "danger" ? "error" : severity}
        sx={{
          width: "100%",
          borderRadius: "12px",
          fontWeight: 500,
          py: isCustomMessage ? 1.25 : undefined,
          px: isCustomMessage ? 1.5 : undefined,
          boxShadow: position === "top-left" ? "0 6px 16px rgba(15, 23, 42, 0.08)" : undefined,
          "& .MuiAlert-message": {
            flex: 1,
          },
          ...getAlertStyle(severity),
          ...(isCustomMessage && position === "top-left"
            ? {
                backgroundColor: colors.orange[50],
                border: `1px solid ${colors.orange[200]}`,
              }
            : {}),
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
